import { useEffect, useState } from "react";
import confetti from "canvas-confetti";
import OffScreen from "./OffScreen.tsx";

export default function Confetti({
  trigger,
  onComplete,
  description,
}: {
  trigger?: boolean;
  onComplete?: () => void;
  description?: string; // a11y
}) {
  const [running, setRunning] = useState<boolean>(false);
  useEffect(() => {
    if (trigger && !running) {
      setRunning(true);
      const p = confetti({ disableForReducedMotion: true });
      // on old systems promise can be null but we have promises
      if (p) {
        void p.then(() => {
          setRunning(false);
          onComplete?.();
        });
      }
    }
  }, [onComplete, running, trigger]);

  return (
    <OffScreen role="status" aria-live="polite">
      {running && description}
    </OffScreen>
  );
}
